import { gql } from "@apollo/client"

const GET_MICROSERVICE_TOKENS = gql`
  {
    telerecovery: token(microservice_id: 1) {
      jwt
    }
    appointments: token(microservice_id: 2) {
      jwt
    }
    notifications: token(microservice_id: 4) {
      jwt
    }
    tasks: token(microservice_id: 5) {
      jwt
    }
    assessments: token(microservice_id: 6) {
      jwt
    }
    documentSign: token(microservice_id: 8) {
      jwt
    }
    googlePlaces: getSecretValue(secret_name: "google_places_api_key") {
      data
    }
  }
`

export { GET_MICROSERVICE_TOKENS }
